// 常见问题数据处理小算法
export function InsuFaqQusetionsArray(str) {
  let patt = new RegExp(/@(.+)[\n/&]+(.+)[\n]/,"g")
  let result
  let arrayd = []
  while ((result = patt.exec(str)) != null)  {
    arrayd.push({
      question: result[1],
      answer: result[2]
    })
  }
  return arrayd
}